<template>
  <v-container>
    <div class="d-flex justify-end">
      <v-breadcrumbs :items="breadItems" divider=">"></v-breadcrumbs>
    </div>
    <v-row>
      <v-col sm="12" md="4" lg="3">
        <v-card min-height="350px" class="border-radius-10">

          <v-row>
            <v-col cols="12">
              <div class="student-profile">
                <div class="student-profile__avatar">
                  <v-img src="../../../assets/profile-photo.png" class="student-profile__photo"></v-img>
                </div>
              </div>

              <div class="student-info">
                <div class="student-info__name">{{ object.std_fname }} {{ object.std_lname }}</div>
                <div class="student-info__email">{{ object.gaurdian_email }}</div>
                <div class="student-info__phone">{{ object.gaurdian_contactno }}</div>
              </div>

              <div class="student-class" v-if="user.user_role == 'Admin'">
                <div style="border-bottom: 1px solid #DCDCDC; margin-top: -15px;" />
                <div class="student-class__info">
                  <div class="student-class__info-title"></div>
                  <div class="student-class__info-value">
                    <v-switch color="green" v-model="switch1"></v-switch>

                  </div>
                </div>

                <div class="student-class__info">
                  <div class="student-class__info-title">Enquiry Date</div>
                  <div class="student-class__info-value">{{ object.creation_time }}</div>
                </div>

                <div class="student-class__info" v-if="object.school_year">
                  <div class="student-class__info-title">Class In The School</div>
                  <div class="student-class__info-value">{{ object.school_year.school_year_name }}</div>
                </div>

                <div class="student-class__info" v-if="false">
                  <div class="student-class__info-title" v-if="object.discount_type === 'amount'">
                    (£{{ object.discount }})</div>
                  <div class="student-class__info-title" v-else>({{ object.discount }} %)</div>
                </div>

              </div>

            </v-col>
          </v-row>
          <div class="student-class" v-if="object.siblings.length > 0">
            <div style="border-bottom: 1px solid #DCDCDC; margin-top: -15px;" />
            <v-row>
              <v-col>
                <h4>Siblings</h4>
                <div v-for="sibling in object.siblings" :key="sibling.id">
                  <router-link class="profile-link" active-class="active" :exact="true"
                    :to="{ name: 'StudentProfile', params: { id: sibling.std_id } }">
                    <p>{{ sibling.std_fname }} {{ sibling.std_lname }}</p>
                  </router-link>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col sm="12" md="8" lg="9">
        <v-card min-height="100%" class="border-radius-10" style="padding: 12px;">
          <v-row style="float: right;">
            <v-col>
              <v-btn color="success" class="profile-button"
                :to="{ name: 'StudentUpload', params: { id: this.$route.params.id } }" small>
                <!-- <v-icon dark>mdi-plus</v-icon> -->
                View Work
              </v-btn>
              <v-btn color="success" class="profile-button" @click="showDialog(object)" small>
                <!-- <v-icon dark>mdi-plus</v-icon> -->
                Add Details
              </v-btn>

              <v-btn class="profile-button" v-if="object.user_id == '0'" color="success" @click="showDialog2(object)"
                small>
                <!-- <v-icon dark>mdi-plus</v-icon> -->
                Set Username
              </v-btn>
              <v-btn class="profile-button" v-else color="success" @click="showDialog2(object)" small>
                <!-- <v-icon dark>mdi-plus</v-icon> -->
                Reset Username
              </v-btn>
            </v-col>
          </v-row>
          <div style="clear:both"></div>
          <!-- class="box-style" -->
          <v-row style="margin:0px;">
            <v-col md="6">
              <div class="tutor-details border-right">
                <h2 class="tutor-details__heading">About Student</h2>
                <v-simple-table class="tutor-details__table" dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <th class="item-name">Full Name</th>
                        <td class="item-value text-right">{{ object.std_fname }} {{ object.std_lname }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Username</th>
                        <td class="item-value text-right">{{ object.std_username ? object.std_username : 'Not Set' }}
                        </td>
                      </tr>
                      <!-- <tr>
                                            <th class="item-name">Email</th>
                                            <td class="item-value text-right">{{ object.std_email }}
                                            </td>
                                        </tr> -->
                      <tr>
                        <th class="item-name">Gender</th>
                        <td class="item-value text-right">{{ object.std_gender }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Tuition Type</th>
                        <td class="item-value text-right">{{ object.std_tuition_type }}
                        </td>
                      </tr>
                      <tr v-if="object.class">
                        <th class="item-name">Year/Class Allocated</th>
                        <td class="item-value text-right">{{ object.class.class_name }}
                        </td>
                      </tr>
                      <tr v-if="object.student_subject">
                        <th class="item-name">Subject Allocated</th>
                        <td class="item-value text-right">
                          <v-chip v-for="(data, index) in object.student_subject" :key="index">
                            {{ data.subject.subject_name }}</v-chip>
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">School Name</th>
                        <td class="item-value text-right">{{ object.std_school_name }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Amount</th>
                        <td class="item-value text-right" v-html="calculateAmount"></td>
                      </tr>
                      <tr>
                        <th class="item-name">Discount</th>
                        <td class="item-value text-right" v-html="calculateDiscount"></td>
                      </tr>

                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>

            <v-col md="6">
              <div class="tutor-details">
                <h2 class="tutor-details__heading">Guardian Details</h2>
                <v-simple-table class="tutor-details__table" dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <th class="item-name">Guardian Name</th>
                        <td class="item-value text-right">{{ object.gaurdian_fname }} {{ object.gaurdian_lname }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Guardian Email</th>
                        <td class="item-value text-right">{{ object.gaurdian_email }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Guardian Contact No</th>
                        <td class="item-value text-right">{{ object.gaurdian_contactno }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Student Address</th>
                        <td class="item-value text-right">{{ object.std_address }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>
          </v-row>

          <hr>
          <v-row>
            <v-col>
              <h2 v-if="object.week_hours">Week Wise Hours</h2>
              <table style="width:100%;border:1px solid lightgrey" v-if="object.week_hours">
                <tr>
                  <th>Mon</th>
                  <th>Tue</th>
                  <th>Wed</th>
                  <th>Thu</th>
                  <th>Fri</th>
                  <th>Sat</th>
                  <th>Sun</th>
                </tr>
                <tr style="text-align: center">
                  <td>{{ object.week_hours.mon }}</td>
                  <td>{{ object.week_hours.tue }}</td>
                  <td>{{ object.week_hours.wed }}</td>
                  <td>{{ object.week_hours.thu }}</td>
                  <td>{{ object.week_hours.fri }}</td>
                  <td>{{ object.week_hours.sat }}</td>
                  <td>{{ object.week_hours.sun }}</td>
                </tr>
              </table>
            </v-col>
          </v-row>
          <v-row class="profile_rows">
            <v-col>
              <div class="notes-header">
                <h2 v-if="object.notes.length > 0">Notes</h2>
                <v-btn small color="primary" @click="addNotesDialog">Add Notes</v-btn>
              </div>
              <div class="horizontal-line-under-notes-header"></div>
              <div class="row" v-for="(note, index) in object.notes" :key="index">
                <div class="col-md-2">
                  <v-img src="../../../assets/profile-photo.png" class="student-profile__photo"
                    style="border-radius:50%" height="70" width="70"></v-img>
                  <p>{{ note.created_at }}</p>
                </div>
                <div class="col-md-10">
                  <p>
                  <div style="float: right">
                    <v-icon @click="editNotes(note)" color="success">mdi-pencil-box</v-icon>
                    <v-icon color="red" @click="deleteNotes(note)">mdi-delete</v-icon>
                  </div>
                  <strong>{{ note.reviewer.name }}</strong>
                  </p>
                  <p>{{ note.notes }}</p>
                </div>
              </div>
            </v-col>

          </v-row>
        </v-card>

      </v-col>
    </v-row>
    <v-dialog v-model="notes_dialog" persistent max-width="600px">
      <!-- <template v-slot:activator="{ on, attrs2 }">

          <v-btn color="#6A158E" dark  v-bind="attrs2"
          v-on="on">+ Add Session</v-btn>
        </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">Add Notes</span>
        </v-card-title>
        <v-card-text>
          <v-container>

            <v-row>

              <v-col>
                <label class="custom-label">Notes</label>

                <v-textarea v-model="data.notes" :error-messages="errors.notes" label="Notes" placeholder="Notes" solo>
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="notes_dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="addNote">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog2" persistent max-width="600px">
      <!-- <template v-slot:activator="{ on, attrs2 }">

          <v-btn color="#6A158E" dark  v-bind="attrs2"
          v-on="on">+ Add Session</v-btn>
        </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">Set Username</span>
        </v-card-title>
        <v-card-text>
          <v-container>

            <v-row>

              <v-col>
                <label class="custom-label">Username</label>

                <v-text-field v-model="data.username" :error-messages="errors.username" label="Username"
                  placeholder="Username" solo></v-text-field>
              </v-col>
            </v-row>
            <v-row>

              <v-col>
                <label class="custom-label">Email</label>

                <v-text-field v-model="data.email" :error-messages="errors.email" label="email"
                  placeholder="Email (optional)" solo></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog2 = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="setUsername">Send Email</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <!-- <template v-slot:activator="{ on, attrs2 }">

          <v-btn color="#6A158E" dark  v-bind="attrs2"
          v-on="on">+ Add Session</v-btn>
        </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">Add Details</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-select v-model="data.selected_class" :items="classes" hide-selected label="Select Class" small-chips
                  item-value="class_id" item-text="class_name">
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <!-- {{data.selected_subject}} -->
                <v-select :items="subjects" multiple label="Choose Subjects" v-model="data.selected_subject"
                  :error-messages="errors.selected_subject" placeholder="Choose Subjects"></v-select>
                <!-- <v-select v-model="data.selected_subject" :items="subjects" hide-selected label="Select Subject" small-chips multiple item-value="subject_id" item-text="subject_name"> -->
                <!-- </v-select> -->
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <label class="custom-label">Joining Date</label>

                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                  :return-value.sync="data.joining_date" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="computedJoiningDate" label="Choose Date" :error-messages="errors.joining_date"
                      prepend-icon readonly v-bind="attrs" v-on="on" solo></v-text-field>
                  </template>
                  <v-date-picker :first-day-of-week="1" v-model="data.joining_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu2.save(data.joining_date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <label class="custom-label">On Holiday / Leaving Date</label>

                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                  :return-value.sync="data.ending_date" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="computedEndingDate" label="Choose Date" :error-messages="errors.ending_date"
                      prepend-icon readonly v-bind="attrs" v-on="on" solo></v-text-field>
                  </template>
                  <v-date-picker :first-day-of-week="1" v-model="data.ending_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu1.save(data.ending_date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <label class="custom-label">Date of birth</label>

                <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false"
                  :return-value.sync="data.date_of_birth" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="computedDOB" label="Choose Date" :error-messages="errors.date_of_birth"
                      prepend-icon readonly v-bind="attrs" v-on="on" solo></v-text-field>
                  </template>
                  <v-date-picker :first-day-of-week="1" v-model="data.date_of_birth" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu3 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu3.save(data.date_of_birth)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col>
                <label class="custom-label">Discount</label>

                <v-row class="discount-section">
                  <v-col style="padding-top:0">
                    <v-text-field v-model="data.discount" :error-messages="errors.mon_hours" label="Discount"
                      placeholder="Discount" solo></v-text-field>
                  </v-col>
                  <v-col style="padding-top:0">
                    <v-checkbox v-model="data.discount_type" class="mx-2" label="Percentage"></v-checkbox>

                  </v-col>
                </v-row>
              </v-col>

              <!--      <v-text-field
                v-model="data.number_of_hours"
                :error-messages="errors.number_of_hours"
                label="Number Of Hours Per Week"
                placeholder="Number Of Hours Per Week"
                solo
              ></v-text-field> -->
            </v-row>
            <v-row>
              <v-col>
                <label class="custom-label">Number Of Hours</label>

              </v-col>
            </v-row>
            <v-row style="width:fit-content">

              <v-col>

                Monday
              </v-col>
              <v-col>
                <v-text-field v-model="data.mon_hours" :error-messages="errors.mon_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>
              <v-col>

                Tuesday
              </v-col>
              <v-col>
                <v-text-field v-model="data.tue_hours" :error-messages="errors.tue_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>
            </v-row>

            <v-row style="width:fit-content">

              <v-col>

                Wednesday
              </v-col>
              <v-col>
                <v-text-field v-model="data.wed_hours" :error-messages="errors.wed_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>
              <v-col>

                Thursday
              </v-col>
              <v-col>
                <v-text-field v-model="data.thu_hours" :error-messages="errors.thu_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>
            </v-row>

            <v-row style="width:fit-content">

              <v-col>

                Friday
              </v-col>
              <v-col>
                <v-text-field v-model="data.fri_hours" :error-messages="errors.fri_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>

              <v-col>

                Saturday
              </v-col>
              <v-col>
                <v-text-field v-model="data.sat_hours" :error-messages="errors.sat_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>
            </v-row>

            <v-row style="width:fit-content">

              <v-col>

                Sunday
              </v-col>
              <v-col>
                <v-text-field v-model="data.sun_hours" :error-messages="errors.sun_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>

              <v-col style="opacity:0">

                Sunday
              </v-col>
              <v-col style="opacity:0">
                <v-text-field v-model="data.no_hours" :error-messages="errors.no_hours" label="No Of Hours"
                  placeholder="No Of Hours" solo dense></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="chooseCLass">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay" style="z-index:99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  name: "Profile",
  components: {},
  data() {
    return {
      data: {
        student_id: this.$route.params.id,
        user_id: JSON.parse(localStorage.getItem("user")).id,
        notes: "",
        joining_date: "",
        ending_date: "",
        date_of_birth: "",
        selected_subject: [],
      },
      overlay: false,
      errors: {},
      notes_dialog: false,
      dialog: false,
      dialog2: false,
      user: JSON.parse(localStorage.getItem("user")),

      switch1: true,
      object: {},
      classes: [],
      subjects: [],
      menu1: false,
      menu2: false,
      menu3: false,
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: "Students",
          disabled: true,
          to: {
            name: "Students",
          },
        },
        {
          text: "Profile",
          disabled: true,
          to: {
            name: "StudentProfile",
          },
        },
      ],
    };
  },
  computed: {
    weekHours() {
      let week_hours = 0;
      if (
        this.object.week_hours != null &&
        typeof this.object.week_hours != "undefined"
      ) {
        week_hours +=
          this.object.week_hours.mon > 0 ? this.object.week_hours.mon : 0;
        week_hours +=
          this.object.week_hours.tue > 0 ? this.object.week_hours.tue : 0;
        week_hours +=
          this.object.week_hours.wed > 0 ? this.object.week_hours.wed : 0;
        week_hours +=
          this.object.week_hours.thu > 0 ? this.object.week_hours.thu : 0;
        week_hours +=
          this.object.week_hours.fri > 0 ? this.object.week_hours.fri : 0;
        week_hours +=
          this.object.week_hours.sat > 0 ? this.object.week_hours.sat : 0;
        week_hours +=
          this.object.week_hours.sun > 0 ? this.object.week_hours.sun : 0;
      }
      return week_hours;
    },
    calculateDiscount() {
      let discount = 0;
      if (
        !this.isEmpty(typeof this.object.discount_type) &&
        !this.isEmpty(typeof this.object.discount)
      ) {
        discount = "£ " + this.object.discount;
        if (this.object.discount_type == "percentage") {
          discount = this.object.discount + " %";
        }
      }
      return discount == 0 ? "£ 0" : discount;
    },
    calculateAmount() {
      return !this.isEmpty(this.object.class)
        ? "£ " + this.object.class.fare_per_hour * this.weekHours
        : "£ " + 0;
    },
    computedJoiningDate() {
      if (this.data.joining_date) {
        return moment(this.data.joining_date).format("DD-MM-YYYY");
      }
    },
    computedEndingDate() {
      if (this.data.ending_date) {
        return moment(this.data.ending_date).format("DD-MM-YYYY");
      }
    },
    computedDOB() {
      if (this.data.date_of_birth) {
        return moment(this.data.date_of_birth).format("DD-MM-YYYY");
      }
    },
  },
  methods: {
    isEmpty(value) {
      return typeof value == "undefined" || value == null;
    },
    deleteNotes(item) {
      // console.log(item)
      this.data.notes_id = item.id;
      Swal2.fire({
        title: "Are you sure to delete this note?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        // console.log(resu)
        if (result.isConfirmed) {
          axios.post("delete/student/notes", this.data).then((response) => {
            console.log(response);
            // this.formalizeTable(response.data);
            // this.notes_dialog = false;
            // this.data.notes = ''
            // this.data.delete_notes = 0;
            this.getDetails();
            // console.log(response)
            // this.classes = response.data.response
          });
        }
      });
    },
    addNotesDialog() {
      this.data.notes_id = 0;
      this.notes_dialog = true;
    },
    editNotes(item) {
      this.notes_dialog = true;
      this.data.notes_id = item.id;
      console.log(item);
      this.data.notes = item.notes;
    },
    setUsername() {
      this.overlay = true;
      // let form = new Form({...this.data})
      // this.overlay = true
      axios
        .post("set/username", this.data)
        .then((response) => {
          this.overlay = false;

          // console.log(response)
          // this.formalizeTable(response.data);
          this.dialog2 = false;
          this.getDetails();
          // this.overlay = false

          // console.log(response)
          // this.classes = response.data.response
        })
        .catch((response) => {
          // console.log("log",response.response.data);
          this.overlay = false;
          if (response.response.status === 422) {
            this.errors = response.response.data.errors;
          }
          this.loading = false;
        });
    },

    chooseCLass() {
      // var data = {
      //   "student_id" : this.student_id,
      //   "class_id" : this.selectedClass
      // }
      axios.post("select/class", this.data).then((response) => {
        // this.formalizeTable(response.data);
        this.dialog = false;
        // this.getItems()
        this.getDetails();
        // console.log(response)
        // this.classes = response.data.response
      });
    },
    showDialog2(item) {
      this.data.student_id = item.std_id;
      this.data.student_user_id = item.user_id;
      this.data.username = item.std_username;
      this.dialog2 = true;
    },
    showDialog(item) {
      //   console.log(item.student_subject);
      this.dialog = true;
      axios.get("classes").then((response) => {
        // this.formalizeTable(response.data);
        // this.loading = false;
        // console.log(response.data)
        this.classes = response.data.response;
        console.log(response.data.response, 'responsessssss');
        // this.subjects = response.data.subjects;

        response.data.subjects.forEach((element) => {
          this.subjects.push({
            value: element.subject_id,
            text: element.subject_name,
          });
        });
        this.data.student_id = item.std_id;
        this.data.joining_date = item.std_joining_date;
        this.data.ending_date = item.std_leaving_date;
        this.data.date_of_birth = item.std_dob;
        this.data.number_of_hours = item.std_no_of_hours;
        this.data.discount = item.discount;
        this.data.discount_type = item.discount_type !== "amount";
        this.data.selected_class = parseInt(item.class_id);
        // this.data.selected_subject = parseInt(item.subject_id);
        // console
        this.data.selected_subject = [
          ...item.student_subject.map((data) =>
            //   console.log(data,'map'),
            parseInt(data.subject_id)
          ),
        ];
        //   this.data.selected_subject = [
        //   ...item.map((subject) =>
        // parseInt(item.subject_id)
        //   ),
        // ];
      });
    },
    addNote() {
      // this.data.notes_id = 0;
      axios.post("add/student/notes", this.data).then((response) => {
        // this.formalizeTable(response.data);
        this.notes_dialog = false;
        this.data.notes = "";
        this.data.delete_notes = 0;
        this.getDetails();
        // console.log(response)
        // this.classes = response.data.response
      });
    },
    getDetails() {
      axios
        .get(apiRoutes.students.url + "/" + this.$route.params.id)
        .then((response) => {
          // console.log(response.data)
          this.object = response.data;
          this.switch1 = response.data.status;
          this.data.mon_hours = response.data.week_hours.mon;
          this.data.tue_hours = response.data.week_hours.tue;
          this.data.wed_hours = response.data.week_hours.wed;
          this.data.thu_hours = response.data.week_hours.thu;
          this.data.fri_hours = response.data.week_hours.fri;
          this.data.sat_hours = response.data.week_hours.sat;
          this.data.sun_hours = response.data.week_hours.sun;
        });
    },
  },
  mounted() {
    this.getDetails();
  },
  watch: {
    switch1: function (val) {
      console.log(val);
      axios
        .get("student/status/update/" + this.$route.params.id + "/" + val)
        .then((response) => {
          console.log(response.data);
          this.object = response.data;
        });
    },
    $route(to, from) {
      // react to route changes...
      this.getDetails();
    },
  },
};
</script>

<style lang="scss" scoped>
.discount-section {
  margin-top: 0px;
}

.v-input--selection-controls__input {
  margin: auto !important;
}

.horizontal-line-under-notes-header {
  border-top: 1px solid #e0e0e0;
  height: 50px;
}

.notes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.border-radius-10 {
  border-radius: 10px;
}

.student-profile {
  height: 175px;
  margin-top: -12px;
  background: #f1efef;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  &__avatar {
    max-height: 120px;
    overflow: hidden;
    width: 120px;
    border-radius: 50%;
    border: 1px solid #6a158e;
    padding: 2px;
    margin-bottom: -20px;
  }
}

.student-info {
  margin-top: 40px;
  text-align: center;

  &__name {
    font: 500 18px/22px Gotham;
    color: #172b4d;
  }

  &__email,
  &__phone {
    font: 400 14px/22px Gotham;
    color: #3f475d99;
  }
}

.student-class {
  padding: 10px 18px;
  margin-top: 30px;
  // border: 0.5px solid #d6dbe1;
  border-left: 0;
  border-right: 0;

  &__info {
    display: flex;
    justify-content: space-between;

    &-title {
      font: 500 14px/20px Gotham;
      color: #172b4d;
    }

    &-value {
      font: 300 14px/13px;
      font-family: "Gotham Narrow";
      color: #8898aa;
    }
  }
}

.student-subjects {
  padding: 10px 18px;
  margin-top: 15px;

  &__btn {
    margin-bottom: 10px;
  }
}

.profile-button {
  margin-left: 5px;
  margin-right: 5px;
}

.profile_rows {
  padding: 10px;
}
</style>
